import { Tag as BPTag, Intent, TagProps } from '@blueprintjs/core';

interface ITagProps {
  className?: string;
  color?: 'green' | 'custom';
  label: string;
}

export default function Tag({ className, color = 'green', label }: Readonly<ITagProps>) {
  const props: TagProps = {
    // lets see if minimal can be applied everywhere
    minimal: true,
    className,
  };
  if (color === 'green') {
    props.intent = Intent.SUCCESS;
  }
  return <BPTag {...props}>{label}</BPTag>;
}
